import { render, staticRenderFns } from "./RestoreAlarmType.vue?vue&type=template&id=33a6f872&scoped=true"
import script from "./RestoreAlarmType.vue?vue&type=script&lang=js"
export * from "./RestoreAlarmType.vue?vue&type=script&lang=js"
import style0 from "./RestoreAlarmType.vue?vue&type=style&index=0&id=33a6f872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a6f872",
  null
  
)

export default component.exports